import Base from "@/controllers/base";
export default class Discount extends Base {
  static chart(selector, data) {
    var canvas, config, ctx, div;
    div = document.getElementById(selector);
    if (div) {
      div.innerHTML = null;
      canvas = document.createElement("canvas");
      div.appendChild(canvas);
      ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      config = {
        type: "bar",
        data: {
          labels: data.labels,
          datasets: data.datasets,
        },
        options: {
          maintainAspectRatio: false,
          barValueSpacing: 10,
          responsive: true,
          hover: {
            mode: "nearest",
            intersect: true,
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              mode: "index",
              intersect: true,
            },
          },
        },
      };
      return new Chart(ctx, config);
    }
  }
}
